var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import Loading from '@doordash/component-loading';
import { Text, Stack } from '@doordash/design-language';
import { FormContainer, FormRow, AddCardError, } from '../PaymentComponents/CardFields/CardFieldsStyles';
import CardInput from '../PaymentComponents/CardFields/CardInput';
import useConfigureVgs from './useConfigureVgs';
import useVgsForm from './useVgsForm';
import { VgsFormFieldName } from './Types/vgsCollect';
import { VgsInputContainer, InputWidth } from './AddVgsCardFormStyles';
import { captureVgsEvent, VgsEvents } from './vgsUtils';
import PaymentStrings from '../PaymentStrings';
export default function AddVgsCardForm(_a) {
    var submitting = _a.submitting, paymentCardTracking = _a.paymentCardTracking, onSuccess = _a.onSuccess, onFinish = _a.onFinish, teamAccountId = _a.teamAccountId;
    var _b = __read(useConfigureVgs(), 3), isVgsLoaded = _b[0], vgsLoadErrorMsg = _b[1], vgsConfig = _b[2];
    var formSubmit = useVgsForm(isVgsLoaded, teamAccountId).formSubmit;
    var _c = __read(React.useState(false), 2), isFormSubmitting = _c[0], setIsFormSubmitting = _c[1];
    var _d = __read(React.useState({
        inlineErrors: {},
        globalError: undefined,
    }), 2), formSubmitErrors = _d[0], setFormSubmitErrors = _d[1];
    var handleSubmit = function () {
        // Reset loading and errors.
        setIsFormSubmitting(true);
        setFormSubmitErrors({ inlineErrors: {}, globalError: undefined });
        paymentCardTracking.onClick();
        formSubmit(handleSubmitSuccess, handleSubmitFailure);
    };
    var handleSubmitSuccess = function () {
        setIsFormSubmitting(false);
        paymentCardTracking.onSuccess(null, 'vgs', { teamAccountId: teamAccountId });
        if (onSuccess) {
            onSuccess();
        }
    };
    var handleSubmitFailure = function (errors) {
        var _a;
        setFormSubmitErrors(errors);
        setIsFormSubmitting(false);
        if (errors.globalError) {
            var reason = errors.globalError.reason;
            var message = errors.globalError.message;
            paymentCardTracking.onFailure(reason, message, 'vgs');
            captureVgsEvent(VgsEvents.AddVgsCardForm, { vgsConfig: vgsConfig, errors: (_a = errors.globalError) === null || _a === void 0 ? void 0 : _a.originalException }, new Error(message));
        }
        else {
            var message = JSON.stringify(errors.inlineErrors);
            paymentCardTracking.onFailure('vgs_validation_failure', message, 'vgs');
        }
        if (onFinish) {
            onFinish();
        }
    };
    React.useEffect(function () {
        if (submitting) {
            handleSubmit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [submitting]);
    if (vgsLoadErrorMsg) {
        captureVgsEvent(VgsEvents.AddVgsCardForm, { vgsConfig: vgsConfig }, new Error(vgsLoadErrorMsg));
        return (React.createElement(Text, { color: Text.Colors.TextError, styles: Text.Styles.Bold16 }, vgsLoadErrorMsg));
    }
    else if (!isVgsLoaded) {
        return React.createElement(Loading, null);
    }
    return (React.createElement(FormContainer, null,
        React.createElement(FormRow, null,
            React.createElement(InputWidth, { isFullWidth: true },
                React.createElement(CardInput, { labelName: PaymentStrings.cardDetailsInputLabel(), error: formSubmitErrors.inlineErrors[VgsFormFieldName.Number] || '' },
                    React.createElement(VgsInputContainer, { id: "cc-number" }))),
            React.createElement(InputWidth, null,
                React.createElement(CardInput, { labelName: PaymentStrings.cardCvcInputLabel(), error: formSubmitErrors.inlineErrors[VgsFormFieldName.CVC] || '' },
                    React.createElement(VgsInputContainer, { id: "cc-cvc" })))),
        React.createElement(FormRow, null,
            React.createElement(InputWidth, null,
                React.createElement(CardInput, { labelName: PaymentStrings.expirationInputLabel(), error: formSubmitErrors.inlineErrors[VgsFormFieldName.Expiration] || '' },
                    React.createElement(VgsInputContainer, { id: "cc-expiration-date" }))),
            vgsConfig.ZIP_REQUIRED && (React.createElement(InputWidth, null,
                React.createElement(CardInput, { labelName: PaymentStrings.zipCodeInputLabel(), error: formSubmitErrors.inlineErrors[VgsFormFieldName.Zip] || '' },
                    React.createElement(VgsInputContainer, { id: "cc-zip" }))))),
        React.createElement(Stack, null),
        !isFormSubmitting && formSubmitErrors.globalError && (React.createElement(AddCardError, null,
            React.createElement(Text, null, formSubmitErrors.globalError.displayMsg)))));
}
